const GET_VIDEOGAMES = 'GET_VIDEOGAMES';
const SEARCH_VIDEOGAMES_BY_NAME = 'SEARCH_VIDEOGAMES_BY_NAME';
const GET_VIDEOGAME_BY_ID = 'GET_VIDEOGAME_BY_ID';
const POST_NEW_VIDEOGAME = 'POST_NEW_VIDEOGAME';
const PUT_VIDEOGAME = 'PUT_VIDEOGAME'
const DELETE_VIDEOGAME_BY_ID = 'DELETE_VIDEOGAME_BY_ID';
const UPDATE_VIDEOGAME_BY_ID = 'UPDATE_VIDEOGAME_BY_ID';
const PAGE_CHANGE = 'PAGE_CHANGE';
const GET_GENRES = 'GET_GENRES'
const GET_PLATFORMS = 'GET_PLATFORMS'
const FILTER_CREATE = 'FILTER_CREATE'
const ORDER_BY_ALPHABET_OR_RATING = 'ORDER_BY_ALPHABET_OR_RATING'
//  const ACTION_N = 'ACTION_N';

module.exports = {
    GET_VIDEOGAMES,
    SEARCH_VIDEOGAMES_BY_NAME,
    GET_VIDEOGAME_BY_ID,
    POST_NEW_VIDEOGAME,
    DELETE_VIDEOGAME_BY_ID,
    UPDATE_VIDEOGAME_BY_ID,
    PAGE_CHANGE,
    GET_GENRES,
    GET_PLATFORMS,
    FILTER_CREATE,
    ORDER_BY_ALPHABET_OR_RATING,
    PUT_VIDEOGAME
}
